export default __webpack_public_path__ + "static/media/tf.44cea64c.jpg";